import { Expose, plainToClass } from "class-transformer";
import sha256 from "crypto-js/sha256";

export interface IUser {
  id: number;
  firstName?: string;
  lastName?: string;
  phoneNumber?: IPhoneNumber;
  email: string;
  marketingConsentAccepted?: boolean;
}

export interface IPhoneNumber {
  number: string;
}

export interface IUserUpdateData {
  firstName: string;
  lastName: string;
  phoneNumber: string;
}

export interface ISignupSubmitData {
  email: string;
  password: string;
  passwordConfirmation: string;
  privacyConsent: boolean;
  marketingConsent?: boolean;
  selectAllConsent?: boolean;
}

export interface ILoginSubmitData {
  email: string;
  password: string;
}

export class User implements IUser {
  @Expose() id: number;
  @Expose() firstName?: string;
  @Expose() lastName?: string;
  @Expose() phoneNumber?: IPhoneNumber;
  @Expose() email: string;
  @Expose() marketingConsentAccepted?: boolean;

  @Expose()
  get hashedEmail(): string {
    return sha256(this.email).toString();
  }
}

export default User;

export function transformToUserClass(user: IUser): User {
  return plainToClass(User, user);
}
